import React, { useState } from "react";
import { X } from "lucide-react";
import axios from "../../routers/axios";

const TestDetailModal = ({ mode = "view", test, onClose, onUpdated }) => {
  const [formData, setFormData] = useState({
    test_name: test?.test_name || "",
    test_code: test?.test_code || "",
    description: test?.description || "",
    is_active: test?.is_active ?? true,
  });
  const [loading, setLoading] = useState(false);

  if (!test) return null;

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.put(`/tests/update/${test.id}`, formData);
      alert("Cập nhật test thành công!");
      onUpdated?.();
      onClose();
    } catch (err) {
      console.error(err);
      alert("Lỗi khi cập nhật test!");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      await axios.delete(`/tests/delete/${test.id}`);
      alert("Đã xóa test thành công!");
      onUpdated?.();
      onClose();
    } catch (err) {
      console.error(err);
      alert("Xóa test thất bại!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-lg w-full p-6">
        {/* Header */}
        <div className="flex justify-between items-center border-b pb-3 mb-4">
          <h2 className="text-lg font-semibold">
            {mode === "view"
              ? "Chi tiết Test"
              : mode === "edit"
              ? "Sửa Test"
              : "Xóa Test"}
          </h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full">
            <X className="w-5 h-5 text-gray-600" />
          </button>
        </div>

        {/* Body */}
        {mode === "view" && (
          <div className="space-y-2">
            <p><strong>Tên:</strong> {test.test_name}</p>
            <p><strong>Mã code:</strong> {test.test_code || "-"}</p>
            <p><strong>Mô tả:</strong> {test.description || "-"}</p>
            <p>
              <strong>Trạng thái:</strong>{" "}
              <span className={test.is_active ? "text-green-600" : "text-red-600"}>
                {test.is_active ? "Hoạt động" : "Ngưng"}
              </span>
            </p>
            <p><strong>Ngày tạo:</strong> {test.created_at}</p>
          </div>
        )}

        {mode === "edit" && (
          <form onSubmit={handleUpdate} className="space-y-4">
            <div>
              <label className="block text-sm font-medium">Tên Test</label>
              <input
                type="text"
                value={formData.test_name}
                onChange={(e) => handleChange("test_name", e.target.value)}
                className="mt-1 block w-full border rounded-lg p-2"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium">Mã code</label>
              <input
                type="text"
                value={formData.test_code}
                onChange={(e) => handleChange("test_code", e.target.value)}
                className="mt-1 block w-full border rounded-lg p-2"
              />
            </div>
            <div>
              <label className="block text-sm font-medium">Mô tả</label>
              <textarea
                value={formData.description}
                onChange={(e) => handleChange("description", e.target.value)}
                className="mt-1 block w-full border rounded-lg p-2"
                rows={3}
              />
            </div>
            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                checked={formData.is_active}
                onChange={(e) => handleChange("is_active", e.target.checked)}
              />
              <span>Kích hoạt</span>
            </div>

            <div className="flex justify-end gap-3">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 border rounded-lg"
              >
                Hủy
              </button>
              <button
                type="submit"
                disabled={loading}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
              >
                {loading ? "Đang lưu..." : "Lưu thay đổi"}
              </button>
            </div>
          </form>
        )}

        {mode === "delete" && (
          <div>
            <p className="mb-4">
              Bạn có chắc chắn muốn xóa test{" "}
              <strong>{test.test_name}</strong>?<br />
              Hành động này không thể hoàn tác.
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={onClose}
                className="px-4 py-2 border rounded-lg"
              >
                Hủy
              </button>
              <button
                onClick={handleDelete}
                disabled={loading}
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
              >
                {loading ? "Đang xóa..." : "Xóa"}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TestDetailModal;
